import React from 'react';
import {createSelector} from 'reselect';

import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';

export default function(prefix='') {
    return createSelector(
        [
            () => this.props.store.get('regionsTreeFilter'),
            () => this.props.store.get('citiesTreeFilter'),
            () => this.props.store.get('levelsTreeFilter'),
        ],
        () => [
            {
                field: prefix + 'region',
                label: window.gettext('Region'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('regionsTreeFilter')}
                        readonly
                        header
                        resource='region'
                        itemLabel='name'
                        label={window.gettext('Region')}
                    />
                </div>,
                selected: this.props.store.getIn(['regionsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'region',
                    this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                )),
            },
            {
                field: prefix + 'city',
                label: window.gettext('City'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('citiesTreeFilter')}
                        readonly
                        header
                        resource='city'
                        itemLabel={city => `${city.region_display} - ${city.name}`}
                        filter={{
                            'region': this.props.store.getIn(['regionsTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('City')}
                    />
                </div>,
                selected: this.props.store.getIn(['citiesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'city',
                    this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                )),
            },
            {
                field: prefix + 'levels',
                label: window.gettext('Level'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('levelsTreeFilter')}
                        readonly
                        header
                        resource='level'
                        label={window.gettext('Level')}
                    />
                </div>,
                selected: this.props.store.getIn(['levelsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'level',
                    this.props.store.getIn(['levelsTreeFilter', 'elementId']),
                )),
            },
        ],
    );
}
